module.exports = __webpack_public_path__ + "static/media/icon_compare_celebrity_inactive.315f20c5.svg";